import Table from '@/common/components/Table';
import React from 'react';
import { HEADERS } from './constants/headers';
import { getRaws } from './helpers/getRaws';

const SpendsTable = ({ spends }) => {
	return (
		<Table className='styled-table' headers={HEADERS} raws={getRaws(spends)} />
	);
};

export default SpendsTable;
